import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
const explore = ["Review the six volumes.", "Explore the visual assessment frameworks.", "Study the mixed dentition reference materials.", "Work through the educational decision pathways.", "Examine the case-planning worksheets.", "Discover how the resources can complement your continuing education."];
export function GuaranteeSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-236" data-mp="15el7jhqnmkoj">
      <div className="mx-auto max-w-3xl" data-id="element-237" data-mp="15d1tlxsh0lpx">
        <div className="rounded-3xl border-2 border-dashed border-cta/50 bg-white px-5 py-10 sm:px-10" data-id="element-238" data-mp="11cq8kjw74jdx">
          <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-cta text-white" data-id="element-239" data-mp="we6l2f1yezjg">
            <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-240" data-mp="2vralubi6tcna" />
            <span className="mt-0.5 text-xs font-black uppercase" data-id="element-241" data-mp="2qry0jv6ysdmt">7 Days</span>
          </div>
          <h2 className="mt-5 text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-242" data-mp="1g4truyexowoi">
            My 7-Day Guarantee
          </h2>
          <p className="mt-2 text-center text-lg font-bold text-cta" data-id="element-243" data-mp="1l5hpw41kyds8">
            Explore the Complete Collection With Confidence
          </p>
          <p className="mx-auto mt-5 max-w-xl text-center text-muted" data-id="element-244" data-mp="1c2yqjtx06jaq">
            I want you to have the opportunity to explore the materials and decide whether they support your
            professional learning needs.
          </p>
          <ul className="mx-auto mt-6 max-w-md space-y-2.5" data-id="element-245" data-mp="23tczdbq5t5fj">
            {explore.map(e => <li key={e} className="flex gap-2.5 text-[15px] font-medium text-navy" data-id="element-246" data-mp="1q1yh5742t89j">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-247" data-mp="1v1b21mbe059h" />
                {e}
              </li>)}
          </ul>
          <p className="mx-auto mt-6 max-w-xl text-center font-semibold text-navy" data-id="element-248" data-mp="2nif2z01lwp3i">
            If the collection isn’t right for you, you may request a refund within seven days, according to the
            published refund policy.
          </p>
        </div>

        <SectionCta label="Explore the complete collection" data-id="element-249" data-mp="2sg2iz1q3u2r6" />
      </div>
    </section>;
}